(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collections-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-grid')) {
    const WKEY = 'petitsol:wishlist';
    const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
    const writeWish = (list) => {
      try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
      document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.hidden = list.length === 0; });
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list, count: list.length } }));
    };

    class PsGrid extends HTMLElement {
      connectedCallback() {
        const root = this.closest('.psg');
        this.syncWish();
        this.addEventListener('click', (e) => this.onClick(e));
        this.onDoc = (e) => { if (!this.contains(e.target)) this.closeAll(); };
        this.onKey = (e) => { if (e.key === 'Escape') this.closeAll(true); };
        this.onWish = () => this.syncWish();
        document.addEventListener('click', this.onDoc);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('wishlist:change', this.onWish);
        if (root) this.reveal(root);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDoc);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('wishlist:change', this.onWish);
      }
      reveal(root) {
        const items = root.querySelectorAll('[data-reveal]');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!root.classList.contains('psg--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach((el) => el.classList.add('is-in')); return; }
        const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.1 });
        items.forEach((el) => io.observe(el));
      }
      syncWish() {
        const list = readWish();
        this.querySelectorAll('[data-wish]').forEach((b) => {
          const on = list.includes(b.dataset.wish);
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      onClick(e) {
        const wish = e.target.closest('[data-wish]');
        if (wish) {
          e.preventDefault();
          let list = readWish();
          const h = wish.dataset.wish;
          list = list.includes(h) ? list.filter((x) => x !== h) : list.concat(h);
          writeWish(list);
          return;
        }
        const quick = e.target.closest('[data-quick]');
        if (quick) {
          e.preventDefault();
          const card = quick.closest('.psg__card');
          const open = card.classList.contains('is-quick');
          this.closeAll();
          if (!open) this.openCard(card);
          return;
        }
        const add = e.target.closest('[data-add]');
        if (add && !add.disabled) {
          e.preventDefault();
          this.addToCart(add);
        }
      }
      openCard(card) {
        const panel = card.querySelector('[data-panel]');
        const btn = card.querySelector('[data-quick]');
        if (!panel) return;
        card.classList.add('is-quick');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        const first = panel.querySelector('[data-add]:not(:disabled)');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), 50);
      }
      closeAll(focus) {
        this.querySelectorAll('.psg__card.is-quick').forEach((card) => {
          card.classList.remove('is-quick');
          const btn = card.querySelector('[data-quick]');
          if (btn) { btn.setAttribute('aria-expanded', 'false'); if (focus) btn.focus({ preventScroll: true }); }
        });
      }
      sectionIds() {
        const ids = [];
        document.querySelectorAll('cart-items-component[data-section-id], [data-cart-section-id]').forEach((el) => {
          const id = el.dataset.sectionId || el.dataset.cartSectionId;
          if (id && !ids.includes(id)) ids.push(id);
        });
        return ids;
      }
      root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
      async cartCount() {
        const r = await fetch(this.root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        const c = await r.json();
        return c.item_count || 0;
      }
      async waitForCount(before, ms) {
        const end = Date.now() + ms;
        while (Date.now() < end) {
          await new Promise((res) => setTimeout(res, 300));
          try { if ((await this.cartCount()) > before) return true; } catch (e) {}
        }
        return false;
      }
      async addToCart(btn) {
        const card = btn.closest('.psg__card');
        const msg = card ? card.querySelector('[data-msg]') : null;
        const pf = card ? card.querySelector('product-form-component') : null;
        const form = pf ? pf.querySelector('form') : null;
        const input = form ? form.querySelector('input[name="id"]') : null;
        const variantId = btn.dataset.add;
        if (this.busy) return;
        this.busy = true;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        if (msg) msg.textContent = '';
        try {
          const before = await this.cartCount();
          if (pf && form && input && customElements.get('product-form-component') && typeof form.requestSubmit === 'function') {
            input.value = variantId;
            input.disabled = false;
            const submitter = form.querySelector('button[type="submit"], input[type="submit"]');
            if (submitter) submitter.disabled = false;
            if (submitter) form.requestSubmit(submitter); else form.requestSubmit();
          } else {
            const res = await fetch(this.root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
          }
          const ok = await this.waitForCount(before, 6000);
          if (!ok) throw new Error(this.dataset.error);
          if (msg) msg.textContent = this.dataset.added;
          this.closeAll();
          this.openDrawer();
        } catch (err) {
          if (msg) msg.textContent = (err && err.message) || this.dataset.error;
        } finally {
          this.busy = false;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }
      }
      openDrawer() {
        document.dispatchEvent(new CustomEvent('petitsol:cart-updated'));
        setTimeout(() => {
          const td = document.getElementById('cart-drawer');
          if (td && typeof td.open === 'function') { if (!td.isOpen) td.open(); return; }
          const cdc = document.querySelector('cart-drawer-component');
          if (cdc) {
            const dlg = cdc.closest('dialog') || cdc.querySelector('dialog');
            if (dlg && dlg.open) return;
            if (typeof cdc.open === 'function') { cdc.open(); return; }
            if (typeof cdc.showDialog === 'function') { cdc.showDialog(); return; }
          }
          window.location.href = this.root() + 'cart';
        }, 350);
      }
    }
    customElements.define('ps-grid', PsGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-grid')) {
    const WKEY = 'petitsol:wishlist';
    const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
    const writeWish = (list) => {
      try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
      document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.hidden = list.length === 0; });
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list, count: list.length } }));
    };

    class PsGrid extends HTMLElement {
      connectedCallback() {
        const root = this.closest('.psg');
        this.syncWish();
        this.addEventListener('click', (e) => this.onClick(e));
        this.onDoc = (e) => { if (!this.contains(e.target)) this.closeAll(); };
        this.onKey = (e) => { if (e.key === 'Escape') this.closeAll(true); };
        this.onWish = () => this.syncWish();
        document.addEventListener('click', this.onDoc);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('wishlist:change', this.onWish);
        if (root) this.reveal(root);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDoc);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('wishlist:change', this.onWish);
      }
      reveal(root) {
        const items = root.querySelectorAll('[data-reveal]');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!root.classList.contains('psg--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach((el) => el.classList.add('is-in')); return; }
        const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.1 });
        items.forEach((el) => io.observe(el));
      }
      syncWish() {
        const list = readWish();
        this.querySelectorAll('[data-wish]').forEach((b) => {
          const on = list.includes(b.dataset.wish);
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      onClick(e) {
        const wish = e.target.closest('[data-wish]');
        if (wish) {
          e.preventDefault();
          let list = readWish();
          const h = wish.dataset.wish;
          list = list.includes(h) ? list.filter((x) => x !== h) : list.concat(h);
          writeWish(list);
          return;
        }
        const quick = e.target.closest('[data-quick]');
        if (quick) {
          e.preventDefault();
          const card = quick.closest('.psg__card');
          const open = card.classList.contains('is-quick');
          this.closeAll();
          if (!open) this.openCard(card);
          return;
        }
        const add = e.target.closest('[data-add]');
        if (add && !add.disabled) {
          e.preventDefault();
          this.addToCart(add);
        }
      }
      openCard(card) {
        const panel = card.querySelector('[data-panel]');
        const btn = card.querySelector('[data-quick]');
        if (!panel) return;
        card.classList.add('is-quick');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        const first = panel.querySelector('[data-add]:not(:disabled)');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), 50);
      }
      closeAll(focus) {
        this.querySelectorAll('.psg__card.is-quick').forEach((card) => {
          card.classList.remove('is-quick');
          const btn = card.querySelector('[data-quick]');
          if (btn) { btn.setAttribute('aria-expanded', 'false'); if (focus) btn.focus({ preventScroll: true }); }
        });
      }
      sectionIds() {
        const ids = [];
        document.querySelectorAll('cart-items-component[data-section-id], [data-cart-section-id]').forEach((el) => {
          const id = el.dataset.sectionId || el.dataset.cartSectionId;
          if (id && !ids.includes(id)) ids.push(id);
        });
        return ids;
      }
      root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
      async cartCount() {
        const r = await fetch(this.root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        const c = await r.json();
        return c.item_count || 0;
      }
      async waitForCount(before, ms) {
        const end = Date.now() + ms;
        while (Date.now() < end) {
          await new Promise((res) => setTimeout(res, 300));
          try { if ((await this.cartCount()) > before) return true; } catch (e) {}
        }
        return false;
      }
      async addToCart(btn) {
        const card = btn.closest('.psg__card');
        const msg = card ? card.querySelector('[data-msg]') : null;
        const pf = card ? card.querySelector('product-form-component') : null;
        const form = pf ? pf.querySelector('form') : null;
        const input = form ? form.querySelector('input[name="id"]') : null;
        const variantId = btn.dataset.add;
        if (this.busy) return;
        this.busy = true;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        if (msg) msg.textContent = '';
        try {
          const before = await this.cartCount();
          if (pf && form && input && customElements.get('product-form-component') && typeof form.requestSubmit === 'function') {
            input.value = variantId;
            input.disabled = false;
            const submitter = form.querySelector('button[type="submit"], input[type="submit"]');
            if (submitter) submitter.disabled = false;
            if (submitter) form.requestSubmit(submitter); else form.requestSubmit();
          } else {
            const res = await fetch(this.root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
          }
          const ok = await this.waitForCount(before, 6000);
          if (!ok) throw new Error(this.dataset.error);
          if (msg) msg.textContent = this.dataset.added;
          this.closeAll();
          this.openDrawer();
        } catch (err) {
          if (msg) msg.textContent = (err && err.message) || this.dataset.error;
        } finally {
          this.busy = false;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }
      }
      openDrawer() {
        document.dispatchEvent(new CustomEvent('petitsol:cart-updated'));
        setTimeout(() => {
          const td = document.getElementById('cart-drawer');
          if (td && typeof td.open === 'function') { if (!td.isOpen) td.open(); return; }
          const cdc = document.querySelector('cart-drawer-component');
          if (cdc) {
            const dlg = cdc.closest('dialog') || cdc.querySelector('dialog');
            if (dlg && dlg.open) return;
            if (typeof cdc.open === 'function') { cdc.open(); return; }
            if (typeof cdc.showDialog === 'function') { cdc.showDialog(); return; }
          }
          window.location.href = this.root() + 'cart';
        }, 350);
      }
    }
    customElements.define('ps-grid', PsGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-announce')) {
    class PsAnnounce extends HTMLElement {
      connectedCallback() {
        this.msgs = Array.from(this.querySelectorAll('[data-msg]'));
        this.i = 0;
        this.querySelectorAll('[data-dir]').forEach((b) => b.addEventListener('click', () => { this.go(this.i + parseInt(b.dataset.dir, 10)); this.restart(); }));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.start(); });
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      ms() { const n = parseInt(this.dataset.interval || '0', 10); return n > 0 ? n * 1000 : 0; }
      start() {
        this.stop();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.ms() || reduce || this.msgs.length < 2) return;
        this.timer = setInterval(() => this.go(this.i + 1), this.ms());
      }
      stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
      restart() { if (!this.matches(':hover') && !this.contains(document.activeElement)) this.start(); }
      go(n) {
        if (!this.msgs.length) return;
        const len = this.msgs.length;
        this.i = ((n % len) + len) % len;
        this.msgs.forEach((m, idx) => {
          const on = idx === this.i;
          m.classList.toggle('is-active', on);
          if (on) m.removeAttribute('aria-hidden'); else m.setAttribute('aria-hidden', 'true');
          m.querySelectorAll('a').forEach((a) => { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
        });
      }
    }
    customElements.define('ps-announce', PsAnnounce);
  }
  document.addEventListener('shopify:block:select', function (e) {
    var host = e.target.closest && e.target.closest('ps-announce');
    if (!host || !host.msgs) return;
    host.stop();
    host.go(host.msgs.indexOf(e.target));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var host = e.target.closest && e.target.closest('ps-announce');
    if (host && host.start) host.start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-cart-drawer')) {
    class PsCartDrawer extends HTMLElement {
      connectedCallback() {
        this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.addEventListener('click', (e) => this.onClick(e));
        this.onKey = (e) => {
          if (!this.isOpen) return;
          if (e.key === 'Escape') this.close();
          if (e.key === 'Tab') this.trap(e);
        };
        document.addEventListener('keydown', this.onKey);
        this.onUpdated = () => this.refresh();
        document.addEventListener('petitsol:cart-updated', this.onUpdated);
        if (this.dataset.intercept === 'true') {
          this.onDocClick = (e) => {
            const a = e.target.closest('a[href]');
            if (!a || this.contains(a) || e.metaKey || e.ctrlKey || e.shiftKey) return;
            let path = '';
            try { path = new URL(a.href, window.location.origin).pathname.replace(/\/$/, ''); } catch (err) { return; }
            if (path === (this.root + 'cart').replace(/\/\//g, '/').replace(/\/$/, '')) { e.preventDefault(); this.open(); }
          };
          document.addEventListener('click', this.onDocClick);
        }
        this.patchFetch();
        window.PetitSolCart = this;
      }
      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('petitsol:cart-updated', this.onUpdated);
        if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
        document.documentElement.style.removeProperty('overflow');
      }
      patchFetch() {
        if (window.__pscdFetch) return;
        window.__pscdFetch = true;
        const orig = window.fetch;
        const self = this;
        window.fetch = function (input, init) {
          const url = typeof input === 'string' ? input : (input && input.url) || '';
          const own = init && init.headers && (init.headers['X-PS-Cart'] || (typeof init.headers.get === 'function' && init.headers.get('X-PS-Cart')));
          const p = orig.apply(this, arguments);
          if (!own && /\/cart\/(add|change|update|clear)/.test(url)) {
            p.then((r) => {
              if (!r.ok) return;
              const isAdd = /\/cart\/add/.test(url);
              const drawer = document.getElementById('cart-drawer');
              if (!drawer || typeof drawer.refresh !== 'function') return;
              drawer.refresh().then(() => { if (isAdd && drawer.dataset.autoOpen === 'true') drawer.open(); });
            }).catch(() => {});
          }
          return p;
        };
      }
      get isOpen() { return this.classList.contains('is-open'); }
      get panel() { return this.querySelector('[data-panel]'); }
      open() {
        const panel = this.panel, ov = this.querySelector('.pscd__overlay');
        if (!panel) return;
        if (this.isOpen) return;
        this.lastFocus = document.activeElement;
        panel.hidden = false; if (ov) ov.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => { this.classList.add('is-open'); });
        document.documentElement.style.overflow = 'hidden';
        setTimeout(() => { const x = this.querySelector('.pscd__x'); if (x) x.focus({ preventScroll: true }); }, 80);
      }
      close() {
        if (!this.isOpen) return;
        this.classList.remove('is-open');
        document.documentElement.style.removeProperty('overflow');
        const panel = this.panel;
        if (panel) panel.setAttribute('aria-hidden', 'true');
        setTimeout(() => {
          if (this.isOpen) return;
          const ov = this.querySelector('.pscd__overlay');
          if (panel) panel.hidden = true; if (ov) ov.hidden = true;
        }, 450);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      }
      trap(e) {
        const f = Array.from(this.panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')).filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      async refresh() {
        try {
          const res = await window.fetch(this.root + '?sections=' + encodeURIComponent(this.dataset.section), { headers: { 'X-PS-Cart': '1' }, cache: 'no-store' });
          const data = await res.json();
          const html = data[this.dataset.section];
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.querySelector('[data-cart-inner]');
          const cur = this.querySelector('[data-cart-inner]');
          if (next && cur) cur.innerHTML = next.innerHTML;
          document.dispatchEvent(new CustomEvent('petitsol:cart-rendered'));
        } catch (e) {}
      }
      msg(t) { const m = this.querySelector('[data-msg]'); if (m) m.textContent = t || ''; }
      async post(path, body) {
        this.classList.add('is-busy');
        try {
          const res = await window.fetch(this.root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-PS-Cart': '1' }, body: JSON.stringify(body) });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
          await this.refresh();
          document.dispatchEvent(new CustomEvent('petitsol:cart-count'));
          this.syncCounts();
        } catch (err) {
          await this.refresh();
          this.msg((err && err.message) || this.dataset.error);
        } finally {
          this.classList.remove('is-busy');
        }
      }
      async syncCounts() {
        try {
          const r = await window.fetch(this.root + 'cart.js', { headers: { Accept: 'application/json', 'X-PS-Cart': '1' }, cache: 'no-store' });
          const c = await r.json();
          document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
          document.dispatchEvent(new CustomEvent('cart:count', { detail: { count: c.item_count } }));
        } catch (e) {}
      }
      onClick(e) {
        if (e.target.closest('[data-close]')) { this.close(); return; }
        const ch = e.target.closest('[data-change]');
        if (ch) { this.post('cart/change.js', { line: parseInt(ch.dataset.change, 10), quantity: Math.max(0, parseInt(ch.dataset.qty, 10) || 0) }); return; }
        const add = e.target.closest('[data-add]');
        if (add) { this.post('cart/add.js', { items: [{ id: parseInt(add.dataset.add, 10), quantity: 1 }] }); }
      }
    }
    customElements.define('ps-cart-drawer', PsCartDrawer);
  }
  document.addEventListener('shopify:section:select', function (e) { var d = e.target.querySelector && e.target.querySelector('ps-cart-drawer'); if (d && d.open) d.open(); });
  document.addEventListener('shopify:section:deselect', function (e) { var d = e.target.querySelector && e.target.querySelector('ps-cart-drawer'); if (d && d.close) d.close(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-collection"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('ps-grid')) {
    const WKEY = 'petitsol:wishlist';
    const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
    const writeWish = (list) => {
      try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
      document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.hidden = list.length === 0; });
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list, count: list.length } }));
    };

    class PsGrid extends HTMLElement {
      connectedCallback() {
        const root = this.closest('.psg');
        this.syncWish();
        this.addEventListener('click', (e) => this.onClick(e));
        this.onDoc = (e) => { if (!this.contains(e.target)) this.closeAll(); };
        this.onKey = (e) => { if (e.key === 'Escape') this.closeAll(true); };
        this.onWish = () => this.syncWish();
        document.addEventListener('click', this.onDoc);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('wishlist:change', this.onWish);
        if (root) this.reveal(root);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDoc);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('wishlist:change', this.onWish);
      }
      reveal(root) {
        const items = root.querySelectorAll('[data-reveal]');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!root.classList.contains('psg--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach((el) => el.classList.add('is-in')); return; }
        const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.1 });
        items.forEach((el) => io.observe(el));
      }
      syncWish() {
        const list = readWish();
        this.querySelectorAll('[data-wish]').forEach((b) => {
          const on = list.includes(b.dataset.wish);
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      onClick(e) {
        const wish = e.target.closest('[data-wish]');
        if (wish) {
          e.preventDefault();
          let list = readWish();
          const h = wish.dataset.wish;
          list = list.includes(h) ? list.filter((x) => x !== h) : list.concat(h);
          writeWish(list);
          return;
        }
        const quick = e.target.closest('[data-quick]');
        if (quick) {
          e.preventDefault();
          const card = quick.closest('.psg__card');
          const open = card.classList.contains('is-quick');
          this.closeAll();
          if (!open) this.openCard(card);
          return;
        }
        const add = e.target.closest('[data-add]');
        if (add && !add.disabled) {
          e.preventDefault();
          this.addToCart(add);
        }
      }
      openCard(card) {
        const panel = card.querySelector('[data-panel]');
        const btn = card.querySelector('[data-quick]');
        if (!panel) return;
        card.classList.add('is-quick');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        const first = panel.querySelector('[data-add]:not(:disabled)');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), 50);
      }
      closeAll(focus) {
        this.querySelectorAll('.psg__card.is-quick').forEach((card) => {
          card.classList.remove('is-quick');
          const btn = card.querySelector('[data-quick]');
          if (btn) { btn.setAttribute('aria-expanded', 'false'); if (focus) btn.focus({ preventScroll: true }); }
        });
      }
      sectionIds() {
        const ids = [];
        document.querySelectorAll('cart-items-component[data-section-id], [data-cart-section-id]').forEach((el) => {
          const id = el.dataset.sectionId || el.dataset.cartSectionId;
          if (id && !ids.includes(id)) ids.push(id);
        });
        return ids;
      }
      root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
      async cartCount() {
        const r = await fetch(this.root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        const c = await r.json();
        return c.item_count || 0;
      }
      async waitForCount(before, ms) {
        const end = Date.now() + ms;
        while (Date.now() < end) {
          await new Promise((res) => setTimeout(res, 300));
          try { if ((await this.cartCount()) > before) return true; } catch (e) {}
        }
        return false;
      }
      async addToCart(btn) {
        const card = btn.closest('.psg__card');
        const msg = card ? card.querySelector('[data-msg]') : null;
        const pf = card ? card.querySelector('product-form-component') : null;
        const form = pf ? pf.querySelector('form') : null;
        const input = form ? form.querySelector('input[name="id"]') : null;
        const variantId = btn.dataset.add;
        if (this.busy) return;
        this.busy = true;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        if (msg) msg.textContent = '';
        try {
          const before = await this.cartCount();
          if (pf && form && input && customElements.get('product-form-component') && typeof form.requestSubmit === 'function') {
            input.value = variantId;
            input.disabled = false;
            const submitter = form.querySelector('button[type="submit"], input[type="submit"]');
            if (submitter) submitter.disabled = false;
            if (submitter) form.requestSubmit(submitter); else form.requestSubmit();
          } else {
            const res = await fetch(this.root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
          }
          const ok = await this.waitForCount(before, 6000);
          if (!ok) throw new Error(this.dataset.error);
          if (msg) msg.textContent = this.dataset.added;
          this.closeAll();
          this.openDrawer();
        } catch (err) {
          if (msg) msg.textContent = (err && err.message) || this.dataset.error;
        } finally {
          this.busy = false;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }
      }
      openDrawer() {
        document.dispatchEvent(new CustomEvent('petitsol:cart-updated'));
        setTimeout(() => {
          const td = document.getElementById('cart-drawer');
          if (td && typeof td.open === 'function') { if (!td.isOpen) td.open(); return; }
          const cdc = document.querySelector('cart-drawer-component');
          if (cdc) {
            const dlg = cdc.closest('dialog') || cdc.querySelector('dialog');
            if (dlg && dlg.open) return;
            if (typeof cdc.open === 'function') { cdc.open(); return; }
            if (typeof cdc.showDialog === 'function') { cdc.showDialog(); return; }
          }
          window.location.href = this.root() + 'cart';
        }, 350);
      }
    }
    customElements.define('ps-grid', PsGrid);
  }

  if (!customElements.get('ps-collection')) {
    const WKEY = 'petitsol:wishlist';
    const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
    class PsCollection extends HTMLElement {
      connectedCallback() {
        document.documentElement.classList.add('js-ready');
        this.saved = false;
        this.onChange = (e) => {
          const t = e.target;
          if (!t.closest('[data-form]') || t.hasAttribute('data-no-auto')) return;
          this.apply();
        };
        this.onSubmit = (e) => { if (e.target.matches('[data-form]')) { e.preventDefault(); this.apply(); } };
        this.onClick = (e) => {
          if (e.target.closest('[data-guide]')) { const d = this.querySelector('[data-guide-dialog]'); if (d && typeof d.showModal === 'function') d.showModal(); return; }
          if (e.target.closest('[data-guide-close]')) { const d = this.querySelector('[data-guide-dialog]'); if (d) d.close(); return; }
          const dlg = e.target.closest('[data-guide-dialog]');
          if (dlg && e.target === dlg) { dlg.close(); return; }
          const more = e.target.closest('[data-more]');
          if (more) { this.toggleMore(); return; }
          const clear = e.target.closest('[data-clear]');
          if (clear) { e.preventDefault(); this.saved = false; this.render(clear.href, true); return; }
          const pageLink = e.target.closest('.pscl__pages a');
          if (pageLink) { e.preventDefault(); this.render(pageLink.href, true, true); return; }
          const load = e.target.closest('[data-load-more]');
          if (load) { e.preventDefault(); this.loadMore(load); return; }
          const sv = e.target.closest('[data-saved]');
          if (sv) { this.saved = !this.saved; this.applySaved(); }
        };
        this.onPop = () => this.render(window.location.href, false);
        this.onWish = () => this.applySaved();
        this.addEventListener('change', this.onChange);
        this.addEventListener('submit', this.onSubmit);
        this.addEventListener('click', this.onClick);
        window.addEventListener('popstate', this.onPop);
        document.addEventListener('wishlist:change', this.onWish);
        this.applySaved();
      }
      disconnectedCallback() {
        window.removeEventListener('popstate', this.onPop);
        document.removeEventListener('wishlist:change', this.onWish);
      }
      get root() { return this.closest('.pscl'); }
      buildUrl() {
        const form = this.querySelector('[data-form]');
        const params = new URLSearchParams();
        new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
        const q = params.toString();
        return this.dataset.base + (q ? '?' + q : '');
      }
      apply() { this.render(this.buildUrl(), true); }
      toggleMore(force) {
        const panel = this.querySelector('[data-more-panel]');
        const btn = this.querySelector('[data-more]');
        if (!panel) return;
        const open = typeof force === 'boolean' ? force : panel.hidden;
        panel.hidden = !open;
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      sectionUrl(url) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(this.dataset.section); }
      async fetchDoc(url) {
        if (this.abort) this.abort.abort();
        this.abort = new AbortController();
        const res = await fetch(this.sectionUrl(url), { signal: this.abort.signal });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return new DOMParser().parseFromString(await res.text(), 'text/html');
      }
      async render(url, push, scroll) {
        const moreOpen = !!(this.querySelector('[data-more-panel]') && !this.querySelector('[data-more-panel]').hidden);
        const active = document.activeElement;
        const focusName = active && active.name ? active.name : null;
        if (this.root) this.root.classList.add('is-loading');
        try {
          const doc = await this.fetchDoc(url);
          const newHost = doc.querySelector('ps-collection');
          if (!newHost) { window.location.href = url; return; }
          ['[data-bar]', '[data-more-panel]', '[data-results]'].forEach((sel) => {
            const cur = this.querySelector(sel);
            const next = newHost.querySelector(sel);
            if (cur && next) cur.innerHTML = next.innerHTML;
            else if (cur && !next) cur.innerHTML = '';
          });
          if (!this.querySelector('[data-more-panel]') && newHost.querySelector('[data-more-panel]')) {
            const form = this.querySelector('[data-form]');
            const noscript = form ? form.querySelector('noscript') : null;
            if (form) form.insertBefore(newHost.querySelector('[data-more-panel]').cloneNode(true), noscript);
          }
          this.toggleMore(moreOpen);
          if (push) history.pushState({ psc: true }, '', url);
          this.applySaved();
          if (focusName) {
            const el = this.querySelector('[name="' + CSS.escape(focusName) + '"]');
            if (el && el.type !== 'radio' && el.type !== 'checkbox') el.focus({ preventScroll: true });
          }
          if (scroll) { const r = this.querySelector('[data-results]'); if (r) r.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        } catch (e) {
          if (e.name !== 'AbortError') window.location.href = url;
        } finally {
          if (this.root) this.root.classList.remove('is-loading');
        }
      }
      async loadMore(link) {
        link.classList.add('is-loading');
        try {
          const doc = await this.fetchDoc(link.href);
          const grid = this.querySelector('[data-grid]');
          const nextGrid = doc.querySelector('[data-grid]');
          if (grid && nextGrid) {
            nextGrid.querySelectorAll(':scope > .psg__card').forEach((c) => { c.classList.add('is-in'); grid.appendChild(c); });
          }
          const nextLoad = doc.querySelector('[data-load-more]');
          if (nextLoad) { link.href = nextLoad.href; link.classList.remove('is-loading'); }
          else { const pager = link.closest('.pscl__pager'); if (pager) pager.remove(); }
          if (grid && typeof grid.syncWish === 'function') grid.syncWish();
          this.applySaved();
        } catch (e) {
          if (e.name !== 'AbortError') window.location.href = link.href;
        }
      }
      applySaved() {
        const list = readWish();
        const btn = this.querySelector('[data-saved]');
        const cnt = this.querySelector('[data-saved-count]');
        if (cnt) cnt.textContent = list.length;
        if (btn) btn.setAttribute('aria-pressed', this.saved ? 'true' : 'false');
        const cards = Array.from(this.querySelectorAll('[data-grid] > .psg__card'));
        let shown = 0;
        cards.forEach((c) => {
          const w = c.querySelector('[data-wish]');
          const keep = !this.saved || (w && list.includes(w.dataset.wish));
          c.hidden = !keep;
          if (keep) shown++;
        });
        this.querySelectorAll('[data-promo]').forEach((p) => { p.hidden = this.saved; });
        const empty = this.querySelector('[data-saved-empty]');
        if (empty) empty.hidden = !(this.saved && shown === 0);
        const count = this.querySelector('[data-count]');
        if (count) {
          const n = this.saved ? shown : parseInt(count.dataset.total || '0', 10);
          count.textContent = n + ' ' + (n === 1 ? count.dataset.wordOne : count.dataset.word);
        }
        this.querySelectorAll('.pscl__pills input[type="radio"]').forEach((r) => { r.closest('.pscl__pill').classList.toggle('is-muted', this.saved); });
      }
    }
    customElements.define('ps-collection', PsCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var form = root.querySelector('[data-psk-form]');
      if (!form || form.dataset.pskInit) return;
      form.dataset.pskInit = '1';
      var success = form.querySelector('[data-success]');
      if (success) { success.focus({ preventScroll: true }); success.scrollIntoView({ block: 'center' }); return; }
      var wrap = form.querySelector('[data-order-wrap]');
      var orderInput = form.querySelector('[data-order-input]');
      function syncOrder() {
        if (!wrap) return;
        var c = form.querySelector('input[type="radio"]:checked');
        var on = !!(c && c.hasAttribute('data-order'));
        wrap.classList.toggle('is-open', on);
        if (orderInput) { orderInput.tabIndex = on ? 0 : -1; if (!on) orderInput.value = ''; }
      }
      form.addEventListener('change', function (e) { if (e.target.type === 'radio') syncOrder(); });
      syncOrder();
      var msg = form.querySelector('textarea');
      var count = form.querySelector('[data-count]');
      function syncCount() { if (msg && count) count.textContent = msg.value.length + ' / ' + (msg.getAttribute('maxlength') || ''); }
      if (msg) msg.addEventListener('input', syncCount);
      syncCount();
      function valid(el) {
        var v = (el.value || '').trim();
        if (el.dataset.rule === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
        if (el.dataset.rule === 'message') return v.length >= (parseInt(el.dataset.min, 10) || 1);
        return v.length > 0;
      }
      form.querySelectorAll('[data-rule]').forEach(function (el) {
        el.addEventListener('blur', function () { if (el.value) el.closest('[data-field]').classList.toggle('is-invalid', !valid(el)); });
        el.addEventListener('input', function () { var f = el.closest('[data-field]'); if (f.classList.contains('is-invalid') && valid(el)) f.classList.remove('is-invalid'); });
      });
      form.addEventListener('submit', function (e) {
        var first = null;
        form.querySelectorAll('[data-rule]').forEach(function (el) {
          var ok = valid(el);
          el.closest('[data-field]').classList.toggle('is-invalid', !ok);
          el.setAttribute('aria-invalid', ok ? 'false' : 'true');
          if (!ok && !first) first = el;
        });
        if (first) { e.preventDefault(); first.focus(); return; }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.classList.add('is-loading');
      });
    }
    function all() { document.querySelectorAll('.psk').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.psk'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-faq')) {
    class PsFaq extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-search]');
        this.items = Array.from(this.querySelectorAll('[data-item]'));
        this.sections = Array.from(this.querySelectorAll('[data-section]'));
        this.links = Array.from(this.querySelectorAll('[data-nav] a'));
        this.items.forEach((it) => { it.dataset.text = it.textContent.toLowerCase().replace(/\s+/g, ' '); });
        if (this.input) this.input.addEventListener('input', () => { clearTimeout(this._t); this._t = setTimeout(() => this.filter(), 120); });
        this.addEventListener('click', (e) => this.onClick(e));
        this.spy();
        if (window.location.hash) setTimeout(() => this.jump(window.location.hash, false), 60);
      }
      onClick(e) {
        const clr = e.target.closest('[data-clear]');
        if (clr) { this.input.value = ''; this.filter(); this.input.focus(); return; }
        const guide = e.target.closest('a[href="#size-guide"], [data-size-guide]');
        if (guide) { const d = this.querySelector('[data-guide-dialog]'); if (d && d.showModal) { e.preventDefault(); d.showModal(); } return; }
        if (e.target.closest('[data-guide-close]')) { const d = this.querySelector('[data-guide-dialog]'); if (d) d.close(); return; }
        const dlg = e.target.closest('[data-guide-dialog]');
        if (dlg && e.target === dlg) { dlg.close(); return; }
        const a = e.target.closest('a[href^="#"]');
        if (a && a.getAttribute('href').length > 1) {
          const hash = a.getAttribute('href');
          if (this.querySelector(hash)) { e.preventDefault(); this.jump(hash, true); }
        }
      }
      jump(hash, push) {
        let el = null;
        try { el = this.querySelector(hash); } catch (err) { return; }
        if (!el) return;
        if (this.input && this.input.value) { this.input.value = ''; this.filter(); }
        if (el.matches('[data-item]')) {
          el.open = true;
          el.classList.remove('is-flash'); void el.offsetWidth; el.classList.add('is-flash');
        }
        el.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        if (push) history.replaceState(null, '', hash);
      }
      filter() {
        const q = (this.input.value || '').trim().toLowerCase();
        const clr = this.querySelector('[data-clear]');
        if (clr) clr.hidden = !q;
        let n = 0;
        this.items.forEach((it) => {
          const hit = !q || q.split(/\s+/).every((w) => it.dataset.text.includes(w));
          it.hidden = !hit;
          if (q && hit) { it.open = true; n++; }
          if (!q) it.open = it.hasAttribute('data-default-open');
        });
        this.sections.forEach((sec) => { sec.hidden = !!q && !sec.querySelector('[data-item]:not([hidden])'); });
        const meta = this.querySelector('[data-meta]');
        const empty = this.querySelector('[data-empty]');
        if (meta) meta.textContent = q ? n + ' ' + (n === 1 ? this.dataset.resultOne : this.dataset.results) + ' “' + this.input.value.trim() + '”' : '';
        if (empty) empty.hidden = !(q && n === 0);
      }
      spy() {
        if (!('IntersectionObserver' in window) || !this.links.length) return;
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting) this.links.forEach((l) => l.classList.toggle('is-active', l.dataset.sec === en.target.id));
          });
        }, { rootMargin: '-30% 0px -60% 0px' });
        this.sections.forEach((sec) => io.observe(sec));
      }
    }
    customElements.define('ps-faq', PsFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-feature-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.pstInit) return;
      root.dataset.pstInit = '1';
      if (!root.classList.contains('pst--reveal')) return;
      var items = root.querySelectorAll('.pst__item');
      if (window.Shopify && window.Shopify.designMode) { root.classList.add('is-editor'); return; }
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { items.forEach(function (i) { i.classList.add('is-in'); }); return; }
      var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (i) { io.observe(i); });
    }
    function all() { document.querySelectorAll('.pst').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.pst')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.psxCartSync) return;
    window.psxCartSync = true;
    const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    let timer = null;
    const refresh = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then((r) => r.json())
          .then((c) => {
            document.querySelectorAll('[data-psx-cart-count]').forEach((el) => { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
            document.querySelectorAll('[data-cart-live]').forEach((el) => { el.textContent = String(c.item_count); });
          })
          .catch(() => {});
      }, 150);
    };
    window.psxRefreshCart = refresh;
    const orig = window.fetch;
    if (typeof orig === 'function') {
      window.fetch = function () {
        const args = arguments;
        const p = orig.apply(this, args);
        try {
          const u = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
          if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(refresh, refresh);
        } catch (e) {}
        return p;
      };
    }
    ['cart:update', 'cart:updated', 'cart:refresh', 'petitsol:cart-updated'].forEach((n) => document.addEventListener(n, refresh));
    window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
  })();

  window.psOpenCart = window.psOpenCart || function () {
    const td = document.getElementById('cart-drawer');
    if (td && typeof td.open === 'function') { if (!td.isOpen) td.open(); return true; }
    const cdc = document.querySelector('cart-drawer-component');
    if (cdc && typeof cdc.open === 'function') { cdc.open(); return true; }
    if (cdc && typeof cdc.showDialog === 'function') { cdc.showDialog(); return true; }
    return false;
  };

  if (!customElements.get('ps-header')) {
    const WKEY = 'petitsol:wishlist';
    const wishCount = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]').length; } catch (e) { return 0; } };
    class PsHeader extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-item].has-sub'));
        this.menu = this.querySelector('[data-menu]');
        this.overlay = this.querySelector('[data-overlay]');
        this.search = this.querySelector('[data-search]');
        this.hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.items.forEach((item) => {
          const trig = item.querySelector('[data-trigger]');
          item.addEventListener('mouseenter', () => { if (this.hoverable.matches) { clearTimeout(item._t); this.openItem(item); } });
          item.addEventListener('mouseleave', () => { if (this.hoverable.matches) { item._t = setTimeout(() => this.closeItem(item), 120); } });
          item.addEventListener('focusin', () => this.openItem(item));
          item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) this.closeItem(item); });
          if (trig) trig.addEventListener('click', (e) => {
            if (!this.hoverable.matches && !item.classList.contains('is-open')) { e.preventDefault(); this.closeAllItems(); this.openItem(item); }
          });
        });
        this.querySelectorAll('[data-open-menu]').forEach((b) => b.addEventListener('click', () => this.openMenu()));
        this.querySelectorAll('[data-close-menu]').forEach((b) => b.addEventListener('click', () => this.closeMenu()));
        if (this.overlay) this.overlay.addEventListener('click', () => this.closeMenu());
        this.querySelectorAll('[data-open-search]').forEach((b) => b.addEventListener('click', () => this.toggleSearch()));
        this.querySelectorAll('[data-close-search]').forEach((b) => b.addEventListener('click', () => this.closeSearch()));
        this.querySelectorAll('[data-open-cart]').forEach((b) => b.addEventListener('click', (e) => {
          if (!window.psOpenCart()) window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
        }));
        this.q = this.querySelector('[data-q]');
        this.results = this.querySelector('[data-results]');
        if (this.q && this.dataset.predictive === 'true') this.q.addEventListener('input', () => { clearTimeout(this._qt); this._qt = setTimeout(() => this.suggest(), 250); });
        this.onKey = (e) => {
          if (e.key !== 'Escape') return;
          if (this.classList.contains('menu-open')) this.closeMenu();
          else if (this.search && !this.search.hidden) this.closeSearch();
          else this.closeAllItems();
        };
        this.onDoc = (e) => {
          if (!this.contains(e.target)) { this.closeAllItems(); if (this.search && !this.search.hidden) this.closeSearch(true); }
        };
        this.onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 4);
        this.onWish = () => this.syncWish();
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('click', this.onDoc);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        document.addEventListener('wishlist:change', this.onWish);
        window.addEventListener('storage', this.onWish);
        this.onScroll();
        this.syncWish();
        this.setHeight();
        this.ro = 'ResizeObserver' in window ? new ResizeObserver(() => this.setHeight()) : null;
        if (this.ro) this.ro.observe(this.querySelector('.psx__bar'));
        this.mq = window.matchMedia('(min-width: 990px)');
        this.onMq = () => { if (this.mq.matches) this.closeMenu(); };
        this.mq.addEventListener('change', this.onMq);
      }
      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onDoc);
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('wishlist:change', this.onWish);
        window.removeEventListener('storage', this.onWish);
        if (this.ro) this.ro.disconnect();
        if (this.mq) this.mq.removeEventListener('change', this.onMq);
        document.documentElement.style.removeProperty('overflow');
      }
      setHeight() {
        const bar = this.querySelector('.psx__bar');
        if (bar) document.documentElement.style.setProperty('--header-height', bar.offsetHeight + 'px');
      }
      syncWish() {
        const n = wishCount();
        this.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
      }
      openItem(item) {
        this.items.forEach((i) => { if (i !== item) this.closeItem(i); });
        item.classList.add('is-open');
        const t = item.querySelector('[data-trigger]');
        if (t) t.setAttribute('aria-expanded', 'true');
      }
      closeItem(item) {
        item.classList.remove('is-open');
        const t = item.querySelector('[data-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
      closeAllItems() { this.items.forEach((i) => this.closeItem(i)); }
      openMenu() {
        if (!this.menu) return;
        this.closeSearch(true);
        this.menu.hidden = false;
        this.overlay.hidden = false;
        requestAnimationFrame(() => this.classList.add('menu-open'));
        document.documentElement.style.overflow = 'hidden';
        const btn = this.querySelector('[data-open-menu]');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        const first = this.menu.querySelector('a, summary, button');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), 60);
        this.menu.addEventListener('keydown', this.trap);
      }
      closeMenu() {
        if (!this.menu || this.menu.hidden) return;
        this.classList.remove('menu-open');
        document.documentElement.style.removeProperty('overflow');
        const btn = this.querySelector('[data-open-menu]');
        if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus({ preventScroll: true }); }
        this.menu.removeEventListener('keydown', this.trap);
        setTimeout(() => { if (!this.classList.contains('menu-open')) { this.menu.hidden = true; this.overlay.hidden = true; } }, 350);
      }
      trap = (e) => {
        if (e.key !== 'Tab') return;
        const f = Array.from(this.menu.querySelectorAll('a[href], button, summary')).filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      };
      toggleSearch() { if (this.search && this.search.hidden) this.openSearch(); else this.closeSearch(); }
      openSearch() {
        if (!this.search) return;
        this.closeAllItems();
        this.search.hidden = false;
        const b = this.querySelector('[data-open-search]');
        if (b) b.setAttribute('aria-expanded', 'true');
        if (this.q) setTimeout(() => this.q.focus(), 30);
      }
      closeSearch(silent) {
        if (!this.search || this.search.hidden) return;
        this.search.hidden = true;
        const b = this.querySelector('[data-open-search]');
        if (b) { b.setAttribute('aria-expanded', 'false'); if (!silent) b.focus({ preventScroll: true }); }
      }
      money(v) {
        const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
        const n = Number(v);
        if (!cur || isNaN(n)) return v;
        try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur, minimumFractionDigits: n % 1 === 0 ? 0 : 2 }).format(n); } catch (e) { return v; }
      }
      async suggest() {
        const term = this.q.value.trim();
        if (!this.results) return;
        if (term.length < 2) { this.results.innerHTML = ''; return; }
        this.abort && this.abort.abort();
        this.abort = new AbortController();
        try {
          const url = this.dataset.suggestUrl + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          const res = await fetch(url, { signal: this.abort.signal, headers: { Accept: 'application/json' } });
          const data = await res.json();
          const items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
          const all = this.dataset.searchUrl + '?q=' + encodeURIComponent(term) + '&options[prefix]=last';
          if (!items.length) { this.results.innerHTML = '<p class="psx__rnone">' + esc(this.dataset.noResults) + '</p>'; return; }
          this.results.innerHTML = '<ul class="psx__rlist" role="list">' + items.map((p) => {
            const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
            const src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
            return '<li><a class="psx__r" href="' + esc(p.url) + '"><span class="psx__r-img">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="300" height="375">' : '') + '</span><span class="psx__r-t">' + esc(p.title) + '</span><span class="psx__r-p">' + esc(this.money(p.price)) + '</span></a></li>';
          }).join('') + '</ul><a class="psx__rall" href="' + esc(all) + '">' + esc(this.dataset.viewAll) + '</a>';
        } catch (e) {
          if (e.name !== 'AbortError') this.results.innerHTML = '';
        }
      }
    }
    customElements.define('ps-header', PsHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function init(root) {
      if (!root || root.dataset.pshInit) return;
      root.dataset.pshInit = '1';
      var items = root.querySelectorAll('[data-reveal]');
      if (!root.classList.contains('psh--reveal') || reduce || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
        }, { threshold: 0.12 });
        items.forEach(function (el) { io.observe(el); });
      }
      if (root.dataset.parallax !== 'true' || reduce) return;
      var layers = root.querySelectorAll('[data-speed]');
      var ticking = false;
      function update() {
        ticking = false;
        var r = root.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var off = (r.top + r.height / 2) - window.innerHeight / 2;
        layers.forEach(function (el) {
          var sp = parseFloat(el.dataset.speed) || 0;
          el.style.transform = 'translate3d(0,' + (off * sp).toFixed(1) + 'px,0)';
        });
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }
    function run() { document.querySelectorAll('.psh').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.psh'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-hotspots"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-hotspots')) {
    class PsHotspots extends HTMLElement {
      connectedCallback() {
        this.spots = Array.from(this.querySelectorAll('.psf__spot'));
        this.feats = Array.from(this.querySelectorAll('.psf__feat'));
        this.spots.forEach((b) => b.addEventListener('click', (e) => {
          e.stopPropagation();
          const i = b.dataset.hot;
          this.set(b.classList.contains('is-active') ? null : i);
          this.stop();
        }));
        this.feats.forEach((li) => {
          li.addEventListener('click', () => { this.set(li.dataset.hot); this.stop(); });
          li.addEventListener('mouseenter', () => { if (window.matchMedia('(hover: hover)').matches) { this.set(li.dataset.hot); this.stop(); } });
        });
        this.onKey = (e) => { if (e.key === 'Escape') this.set(null); };
        this.onDoc = (e) => { if (!this.contains(e.target)) this.set(null); };
        document.addEventListener('keydown', this.onKey);
        if (window.matchMedia('(max-width: 749px)').matches) document.addEventListener('click', this.onDoc);
        this.reveal();
        const sec = parseInt(this.dataset.autoplay || '0', 10);
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (sec > 0 && !reduce && this.feats.length > 1) {
          this.timer = setInterval(() => {
            const cur = this.feats.findIndex((f) => f.classList.contains('is-active'));
            this.set(String((cur + 1) % this.feats.length));
          }, sec * 1000);
        }
      }
      disconnectedCallback() {
        this.stop();
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onDoc);
      }
      stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
      set(i) {
        this.spots.forEach((b) => { const on = b.dataset.hot === i; b.classList.toggle('is-active', on); b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
        this.feats.forEach((f) => f.classList.toggle('is-active', f.dataset.hot === i));
      }
      reveal() {
        const root = this.closest('.psf');
        if (!root) return;
        const items = root.querySelectorAll('[data-reveal]');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!root.classList.contains('psf--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach((el) => el.classList.add('is-in')); return; }
        const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.1 });
        items.forEach((el) => io.observe(el));
      }
    }
    customElements.define('ps-hotspots', PsHotspots);
  }
  document.addEventListener('shopify:block:select', function (e) {
    var host = e.target.closest && e.target.closest('ps-hotspots');
    if (host && host.set && e.target.dataset.hot !== undefined) { host.stop(); host.set(e.target.dataset.hot); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-instagram"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.revInit) return;
      root.dataset.revInit = '1';
      var items = root.querySelectorAll('[data-reveal]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!root.classList.contains('psi--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.1 });
      items.forEach(function (el) { io.observe(el); });
    }
    function run() { document.querySelectorAll('.psi').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.psi'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('psnp-popup')) {
    const store = {
      get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
      set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} },
      sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
      sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
    };
    class PsnpPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.psnp__dialog');
        this.key = 'psnp:' + this.dataset.id;
        this.mq = window.matchMedia('(min-width: 750px)');
        const cfg = (this.mq.matches ? this.dataset.d : this.dataset.m).split(',').map(Number);
        this.cfg = { on: cfg[0] === 1, scroll: cfg[1] || 0, delay: (cfg[2] || 0) * 1000, days: cfg[3] || 0 };
        this.onKey = (e) => this.key_(e);
        this.querySelectorAll('[data-psnp-close]').forEach((b) => b.addEventListener('click', () => this.close(true)));
        const ov = this.querySelector('[data-psnp-overlay]');
        if (ov) ov.addEventListener('click', () => { if (this.dataset.overlayClose === 'true') this.close(true); });
        const form = this.querySelector('form');
        if (form) form.addEventListener('submit', () => store.set(this.key + ':submitted', '1'));

        if (window.Shopify && window.Shopify.designMode) { if (this.dataset.editor === 'true') this.open(false); return; }

        const posted = store.get(this.key + ':submitted') === '1';
        if (posted && (this.querySelector('[data-psnp-success]') || this.querySelector('[data-psnp-error]'))) {
          store.set(this.key + ':submitted', '0');
          if (this.querySelector('[data-psnp-success]')) store.set(this.key + ':subscribed', '1');
          if (/^#PsnpForm-/.test(window.location.hash)) {
            try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) {}
          }
          this.open(true);
          window.addEventListener('load', () => { this.resetScroll(); setTimeout(() => this.resetScroll(), 50); }, { once: true });
          return;
        }

        if (!this.cfg.on || !this.allowed()) return;
        this.arm();
      }
      disconnectedCallback() { this.disarm(); document.removeEventListener('keydown', this.onKey); this.unlock(); }
      resetScroll() {
        [this.dialog, this.querySelector('.psnp__panel')].forEach((el) => { if (el) { el.scrollTop = 0; el.scrollLeft = 0; } });
      }
      allowed() {
        if (this.dataset.hideSubscribed === 'true' && store.get(this.key + ':subscribed') === '1') return false;
        if (this.cfg.days === 0) return store.sget(this.key + ':seen') !== '1';
        const last = parseInt(store.get(this.key + ':closed') || '0', 10);
        return !last || Date.now() - last >= this.cfg.days * 86400000;
      }
      scroller() {
        const w = document.querySelector('.page-wrapper');
        if (w && /(auto|scroll)/.test(getComputedStyle(w).overflowY) && w.scrollHeight > w.clientHeight + 1) return w;
        return document.scrollingElement || document.documentElement;
      }
      progress() {
        const sc = this.scroller();
        const max = sc.scrollHeight - sc.clientHeight;
        if (max <= 4) return 100;
        return (sc.scrollTop / max) * 100;
      }
      arm() {
        this.check = () => {
          if (this.progress() + 0.5 >= this.cfg.scroll) {
            this.disarm();
            this.timer = setTimeout(() => this.open(true), this.cfg.delay);
          }
        };
        document.addEventListener('scroll', this.check, { passive: true, capture: true });
        window.addEventListener('resize', this.check, { passive: true });
        if (document.readyState === 'complete') this.check();
        else window.addEventListener('load', this.check, { once: true });
      }
      disarm() {
        if (!this.check) return;
        document.removeEventListener('scroll', this.check, { capture: true });
        window.removeEventListener('resize', this.check);
      }
      modal() {
        return this.mq.matches ? this.classList.contains('psnp--d-center') : true;
      }
      lock() { if (this.modal()) { document.documentElement.setAttribute('scroll-lock', ''); document.documentElement.style.overflow = 'hidden'; } }
      unlock() { if (this.locked) { document.documentElement.removeAttribute('scroll-lock'); document.documentElement.style.removeProperty('overflow'); this.locked = false; } }
      open(focus) {
        if (this.classList.contains('is-open')) return;
        this.lastFocus = document.activeElement;
        this.hidden = false;
        store.sset(this.key + ':seen', '1');
        if (this.modal()) { this.lock(); this.locked = true; }
        requestAnimationFrame(() => requestAnimationFrame(() => { this.classList.add('is-open'); this.resetScroll(); }));
        document.addEventListener('keydown', this.onKey);
        if (focus) setTimeout(() => { const t = this.modal() && this.mq.matches ? (this.dialog.querySelector('.psnp__input') || this.dialog.querySelector('[data-psnp-close]')) : null; (t || this.dialog).focus({ preventScroll: true }); }, 60);
      }
      close(remember) {
        if (remember && !(window.Shopify && window.Shopify.designMode)) store.set(this.key + ':closed', String(Date.now()));
        this.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKey);
        this.unlock();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(() => { if (!this.classList.contains('is-open')) this.hidden = true; }, reduce ? 0 : 400);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      }
      key_(e) {
        if (e.key === 'Escape') { this.close(true); return; }
        if (e.key !== 'Tab' || !this.modal()) return;
        const f = Array.from(this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])')).filter((n) => n.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    customElements.define('psnp-popup', PsnpPopup);
    document.addEventListener('shopify:section:select', (e) => { const p = e.target.querySelector('psnp-popup'); if (p) p.open(false); });
    document.addEventListener('shopify:section:deselect', (e) => { const p = e.target.querySelector('psnp-popup'); if (p && p.dataset.editor !== 'true') p.close(false); });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.revInit) return;
      root.dataset.revInit = '1';
      var items = root.querySelectorAll('[data-reveal]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!root.classList.contains('psc--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.1 });
      items.forEach(function (el) { io.observe(el); });
    }
    function run() { document.querySelectorAll('.psc').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.psc'); if (r) init(r); });
  })();
  (function () {
    function resetPanels() {
      document.querySelectorAll('.psc__panel').forEach(function (panel) {
        if (panel.scrollTop) panel.scrollTop = 0;
        if (panel.scrollLeft) panel.scrollLeft = 0;
      });
    }
    if (document.readyState !== 'loading') resetPanels(); else document.addEventListener('DOMContentLoaded', resetPanels);
    window.addEventListener('load', function () { resetPanels(); requestAnimationFrame(resetPanels); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-product')) {
    const WKEY = 'petitsol:wishlist';
    const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
    class PsProduct extends HTMLElement {
      connectedCallback() {
        try { this.variants = JSON.parse(this.querySelector('[data-variants]').textContent); } catch (e) { this.variants = []; }
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('.psp__slide'));
        this.sizePos = parseInt(this.dataset.sizePos || '0', 10);
        this.picked = this.dataset.require !== 'true';
        this.addEventListener('change', (e) => { if (e.target.matches('[data-opt]')) this.onOption(e.target); });
        this.addEventListener('click', (e) => this.onClick(e));
        if (this.track) this.track.addEventListener('scroll', () => { cancelAnimationFrame(this._r); this._r = requestAnimationFrame(() => this.onScroll()); }, { passive: true });
        const qty = this.querySelector('[data-qty]');
        if (qty) qty.addEventListener('change', () => { const n = Math.max(1, parseInt(qty.value, 10) || 1); qty.value = n; });
        this.onWish = () => this.syncWish();
        document.addEventListener('wishlist:change', this.onWish);
        this.syncWish();
        this.update(false);
      }
      disconnectedCallback() { document.removeEventListener('wishlist:change', this.onWish); }
      root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
      selected() {
        const out = [];
        this.querySelectorAll('fieldset[data-option]').forEach((fs) => {
          const i = parseInt(fs.dataset.option, 10);
          const c = fs.querySelector('input:checked');
          out[i - 1] = c ? c.value : null;
        });
        return out;
      }
      findVariant(sel) {
        return this.variants.find((v) => v.options.every((o, i) => sel[i] == null || sel[i] === o)) || null;
      }
      exact(sel) {
        if (sel.some((x) => x == null)) return null;
        return this.variants.find((v) => v.options.every((o, i) => sel[i] === o)) || null;
      }
      onOption(input) {
        const oi = parseInt(input.dataset.opt, 10);
        if (oi === this.sizePos) this.picked = true;
        const label = this.querySelector('[data-opt-value="' + oi + '"]');
        if (label) label.textContent = input.value;
        this.update(true);
        const note = this.querySelector('[data-note]');
        if (note && oi === this.sizePos) note.textContent = '';
      }
      update(fromUser) {
        const sel = this.selected();
        if (!this.variants.length) return;
        const fieldsets = Array.from(this.querySelectorAll('fieldset[data-option]'));
        fieldsets.forEach((fs) => {
          const i = parseInt(fs.dataset.option, 10) - 1;
          fs.querySelectorAll('input[data-opt]').forEach((inp) => {
            const test = sel.slice(); test[i] = inp.value;
            const v = this.variants.find((vv) => vv.options.every((o, k) => test[k] == null || test[k] === o));
            const label = inp.closest('label');
            const sold = !v || !v.available;
            label.classList.toggle('is-sold', sold);
            inp.setAttribute('aria-disabled', sold ? 'true' : 'false');
            const low = label.querySelector('.psp__low');
            if (low) low.hidden = !(v && v.low);
          });
        });
        const variant = this.exact(sel) || (this.picked ? null : this.findVariant(sel));
        this.current = this.exact(sel);
        const btn = this.querySelector('[data-add-btn]');
        const text = this.querySelector('[data-add-text]');
        const priceEl = this.querySelector('[data-price]');
        const cmp = this.querySelector('[data-compare]');
        const show = variant || this.variants[0];
        if (priceEl && show) priceEl.textContent = show.price;
        if (cmp) { if (show && show.compare) { cmp.textContent = show.compare; cmp.hidden = false; } else { cmp.hidden = true; } }
        if (btn && text) {
          const avail = this.current ? this.current.available : (show ? true : false);
          btn.disabled = this.current ? !this.current.available : false;
          const priceHtml = this.dataset.showPrice === 'true' && show ? '<span class="psp__add-price"> — <span data-add-price>' + show.price + '</span></span>' : '';
          text.innerHTML = (this.current && !this.current.available) ? this.escape(this.dataset.sold) : this.escape(this.dataset.add) + priceHtml;
        }
        if (this.current) {
          const inp = this.querySelector('[data-variant-input]');
          if (inp) inp.value = this.current.id;
          if (fromUser) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', this.current.id);
            history.replaceState({}, '', url.toString());
            if (this.current.media > 0) this.goToMedia(this.current.media);
          }
        }
      }
      escape(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
      goToMedia(id) {
        const idx = this.slides.findIndex((sl) => sl.dataset.mediaId === String(id));
        if (idx > -1) this.goTo(idx);
      }
      goTo(i) {
        if (!this.track || !this.slides.length) return;
        const n = (i + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.slides[n].offsetLeft - this.track.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        this.setIndex(n);
      }
      onScroll() {
        if (!this.track || !this.slides.length) return;
        const w = this.track.clientWidth || 1;
        this.setIndex(Math.round(this.track.scrollLeft / w));
      }
      setIndex(n) {
        if (this.index !== n) this.pauseMedia(n);
        this.index = n;
        const c = this.querySelector('[data-count]');
        if (c) c.textContent = (n + 1) + ' / ' + this.slides.length;
        this.querySelectorAll('[data-thumb]').forEach((t) => {
          const on = parseInt(t.dataset.thumb, 10) === n;
          t.classList.toggle('is-active', on);
          if (t.hasAttribute('aria-selected')) t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      pauseMedia(active) {
        this.slides.forEach((sl, i) => {
          if (i === active) return;
          sl.querySelectorAll('video').forEach((v) => { try { v.pause(); } catch (e) {} });
          sl.querySelectorAll('iframe').forEach((f) => {
            try {
              f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
              f.contentWindow.postMessage('{"method":"pause"}', '*');
            } catch (e) {}
          });
        });
      }
      syncWish() {
        const b = this.querySelector('[data-wish]');
        if (!b) return;
        const on = readWish().includes(b.dataset.wish);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      async cartCount() {
        const r = await fetch(this.root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        return (await r.json()).item_count || 0;
      }
      async waitFor(before, ms) {
        const end = Date.now() + ms;
        while (Date.now() < end) {
          await new Promise((r) => setTimeout(r, 300));
          try { if ((await this.cartCount()) > before) return true; } catch (e) {}
        }
        return false;
      }
      onClick(e) {
        const thumb = e.target.closest('[data-thumb]');
        if (thumb) { this.goTo(parseInt(thumb.dataset.thumb, 10)); return; }
        const step = e.target.closest('[data-step]');
        if (step) { this.goTo((this.index || 0) + parseInt(step.dataset.step, 10)); return; }
        const q = e.target.closest('[data-q]');
        if (q) { const inp = this.querySelector('[data-qty]'); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.dataset.q, 10)); return; }
        const wish = e.target.closest('[data-wish]');
        if (wish) {
          let list = readWish(); const h = wish.dataset.wish;
          list = list.includes(h) ? list.filter((x) => x !== h) : list.concat(h);
          try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (err) {}
          document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.hidden = list.length === 0; });
          document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list, count: list.length } }));
          return;
        }
        if (e.target.closest('[data-guide]')) { const d = this.querySelector('[data-guide-dialog]'); if (d && d.showModal) d.showModal(); return; }
        if (e.target.closest('[data-guide-close]')) { const d = this.querySelector('[data-guide-dialog]'); if (d) d.close(); return; }
        const dlg = e.target.closest('[data-guide-dialog]');
        if (dlg && e.target === dlg) { dlg.close(); return; }
        if (e.target.closest('[data-add-btn]')) this.add();
      }
      async add() {
        const btn = this.querySelector('[data-add-btn]');
        const msg = this.querySelector('[data-msg]');
        if (!this.current) {
          const note = this.querySelector('[data-note]');
          if (note) note.textContent = this.dataset.pick; else if (msg) msg.textContent = this.dataset.pick;
          if (btn) { btn.classList.remove('is-shake'); void btn.offsetWidth; btn.classList.add('is-shake'); }
          const fs = this.querySelector('fieldset[data-option="' + this.sizePos + '"] input');
          if (fs) fs.focus({ preventScroll: false });
          return;
        }
        if (!this.current.available || this.busy) return;
        this.busy = true;
        if (btn) btn.classList.add('is-loading');
        if (msg) msg.textContent = '';
        const qty = Math.max(1, parseInt((this.querySelector('[data-qty]') || {}).value, 10) || 1);
        try {
          const before = await this.cartCount();
          const pf = this.querySelector('product-form-component');
          const form = pf ? pf.querySelector('form') : null;
          if (pf && form && customElements.get('product-form-component') && typeof form.requestSubmit === 'function') {
            form.querySelector('[data-variant-input]').value = this.current.id;
            form.querySelector('[data-qty-input]').value = qty;
            const sub = form.querySelector('button[type="submit"]');
            if (sub) { sub.disabled = false; form.requestSubmit(sub); } else form.requestSubmit();
          } else {
            const res = await fetch(this.root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: this.current.id, quantity: qty }] }) });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
          }
          if (!(await this.waitFor(before, 6000))) throw new Error(this.dataset.error);
          if (msg) msg.textContent = this.dataset.added;
          document.dispatchEvent(new CustomEvent('petitsol:cart-updated'));
          setTimeout(() => {
            const td = document.getElementById('cart-drawer');
            if (td && typeof td.open === 'function') { if (!td.isOpen) td.open(); return; }
            const cdc = document.querySelector('cart-drawer-component');
            if (cdc && typeof cdc.open === 'function') { cdc.open(); return; }
            if (cdc && typeof cdc.showDialog === 'function') { cdc.showDialog(); return; }
            window.location.href = this.root() + 'cart';
          }, 350);
        } catch (err) {
          if (msg) msg.textContent = (err && err.message) || this.dataset.error;
        } finally {
          this.busy = false;
          if (btn) btn.classList.remove('is-loading');
        }
      }
    }
    customElements.define('ps-product', PsProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-related"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('ps-grid')) {
    const WKEY = 'petitsol:wishlist';
    const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
    const writeWish = (list) => {
      try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
      document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.hidden = list.length === 0; });
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list, count: list.length } }));
    };

    class PsGrid extends HTMLElement {
      connectedCallback() {
        const root = this.closest('.psg');
        this.syncWish();
        this.addEventListener('click', (e) => this.onClick(e));
        this.onDoc = (e) => { if (!this.contains(e.target)) this.closeAll(); };
        this.onKey = (e) => { if (e.key === 'Escape') this.closeAll(true); };
        this.onWish = () => this.syncWish();
        document.addEventListener('click', this.onDoc);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('wishlist:change', this.onWish);
        if (root) this.reveal(root);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDoc);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('wishlist:change', this.onWish);
      }
      reveal(root) {
        const items = root.querySelectorAll('[data-reveal]');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!root.classList.contains('psg--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach((el) => el.classList.add('is-in')); return; }
        const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.1 });
        items.forEach((el) => io.observe(el));
      }
      syncWish() {
        const list = readWish();
        this.querySelectorAll('[data-wish]').forEach((b) => {
          const on = list.includes(b.dataset.wish);
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      onClick(e) {
        const wish = e.target.closest('[data-wish]');
        if (wish) {
          e.preventDefault();
          let list = readWish();
          const h = wish.dataset.wish;
          list = list.includes(h) ? list.filter((x) => x !== h) : list.concat(h);
          writeWish(list);
          return;
        }
        const quick = e.target.closest('[data-quick]');
        if (quick) {
          e.preventDefault();
          const card = quick.closest('.psg__card');
          const open = card.classList.contains('is-quick');
          this.closeAll();
          if (!open) this.openCard(card);
          return;
        }
        const add = e.target.closest('[data-add]');
        if (add && !add.disabled) {
          e.preventDefault();
          this.addToCart(add);
        }
      }
      openCard(card) {
        const panel = card.querySelector('[data-panel]');
        const btn = card.querySelector('[data-quick]');
        if (!panel) return;
        card.classList.add('is-quick');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        const first = panel.querySelector('[data-add]:not(:disabled)');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), 50);
      }
      closeAll(focus) {
        this.querySelectorAll('.psg__card.is-quick').forEach((card) => {
          card.classList.remove('is-quick');
          const btn = card.querySelector('[data-quick]');
          if (btn) { btn.setAttribute('aria-expanded', 'false'); if (focus) btn.focus({ preventScroll: true }); }
        });
      }
      sectionIds() {
        const ids = [];
        document.querySelectorAll('cart-items-component[data-section-id], [data-cart-section-id]').forEach((el) => {
          const id = el.dataset.sectionId || el.dataset.cartSectionId;
          if (id && !ids.includes(id)) ids.push(id);
        });
        return ids;
      }
      root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
      async cartCount() {
        const r = await fetch(this.root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        const c = await r.json();
        return c.item_count || 0;
      }
      async waitForCount(before, ms) {
        const end = Date.now() + ms;
        while (Date.now() < end) {
          await new Promise((res) => setTimeout(res, 300));
          try { if ((await this.cartCount()) > before) return true; } catch (e) {}
        }
        return false;
      }
      async addToCart(btn) {
        const card = btn.closest('.psg__card');
        const msg = card ? card.querySelector('[data-msg]') : null;
        const pf = card ? card.querySelector('product-form-component') : null;
        const form = pf ? pf.querySelector('form') : null;
        const input = form ? form.querySelector('input[name="id"]') : null;
        const variantId = btn.dataset.add;
        if (this.busy) return;
        this.busy = true;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        if (msg) msg.textContent = '';
        try {
          const before = await this.cartCount();
          if (pf && form && input && customElements.get('product-form-component') && typeof form.requestSubmit === 'function') {
            input.value = variantId;
            input.disabled = false;
            const submitter = form.querySelector('button[type="submit"], input[type="submit"]');
            if (submitter) submitter.disabled = false;
            if (submitter) form.requestSubmit(submitter); else form.requestSubmit();
          } else {
            const res = await fetch(this.root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
          }
          const ok = await this.waitForCount(before, 6000);
          if (!ok) throw new Error(this.dataset.error);
          if (msg) msg.textContent = this.dataset.added;
          this.closeAll();
          this.openDrawer();
        } catch (err) {
          if (msg) msg.textContent = (err && err.message) || this.dataset.error;
        } finally {
          this.busy = false;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }
      }
      openDrawer() {
        document.dispatchEvent(new CustomEvent('petitsol:cart-updated'));
        setTimeout(() => {
          const td = document.getElementById('cart-drawer');
          if (td && typeof td.open === 'function') { if (!td.isOpen) td.open(); return; }
          const cdc = document.querySelector('cart-drawer-component');
          if (cdc) {
            const dlg = cdc.closest('dialog') || cdc.querySelector('dialog');
            if (dlg && dlg.open) return;
            if (typeof cdc.open === 'function') { cdc.open(); return; }
            if (typeof cdc.showDialog === 'function') { cdc.showDialog(); return; }
          }
          window.location.href = this.root() + 'cart';
        }, 350);
      }
    }
    customElements.define('ps-grid', PsGrid);
  }

  if (!customElements.get('ps-related')) {
    class PsRelated extends HTMLElement {
      connectedCallback() {
        const section = this.closest('.psr');
        const hasCards = !!this.querySelector('[data-related-grid] .psg__card');
        if (!hasCards && section && !(window.Shopify && window.Shopify.designMode)) section.classList.add('is-empty');
        if (this.dataset.useRecs !== 'true' || this.dataset.performed === 'true') return;
        if (!/product_id=\d/.test(this.dataset.url || '')) return;
        this.load(section, hasCards);
      }
      async load(section, hasCards) {
        try {
          const res = await fetch(this.dataset.url);
          if (!res.ok) return;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const next = doc.querySelector('ps-related [data-related-body]');
          if (next && next.querySelector('[data-related-grid] .psg__card')) {
            this.querySelector('[data-related-body]').innerHTML = next.innerHTML;
            this.querySelectorAll('.psg__card').forEach((c) => c.classList.add('is-in'));
            if (section) section.classList.remove('is-empty');
          } else if (!hasCards && section && !(window.Shopify && window.Shopify.designMode)) {
            section.classList.add('is-empty');
          }
        } catch (e) {}
      }
    }
    customElements.define('ps-related', PsRelated);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-reviews')) {
    class PsReviews extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.btns = Array.from(this.querySelectorAll('[data-dir]'));
        if (!this.track) return;
        this.btns.forEach((b) => b.addEventListener('click', () => this.go(parseInt(b.dataset.dir, 10))));
        this.onScroll = () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.update()); };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.update();
      }
      disconnectedCallback() { window.removeEventListener('resize', this.onScroll); }
      step() {
        const card = this.track.firstElementChild;
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      go(dir) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: dir * this.step(), behavior: reduce ? 'auto' : 'smooth' });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.btns[0]) this.btns[0].disabled = this.track.scrollLeft <= 2;
        if (this.btns[1]) this.btns[1].disabled = this.track.scrollLeft >= max;
      }
      show(el) {
        if (!el || !this.track) return;
        this.track.scrollTo({ left: el.offsetLeft - this.track.offsetLeft, behavior: 'auto' });
      }
    }
    customElements.define('ps-reviews', PsReviews);
  }
  document.addEventListener('shopify:block:select', function (e) {
    var host = e.target.closest && e.target.closest('ps-reviews');
    if (host && host.show) host.show(e.target);
  });
  (function () {
    function init(root) {
      if (!root || root.dataset.revInit) return;
      root.dataset.revInit = '1';
      var items = root.querySelectorAll('[data-reveal]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!root.classList.contains('psr--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.1 });
      items.forEach(function (el) { io.observe(el); });
    }
    function run() { document.querySelectorAll('.psr').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.psr'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-section-links"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ps-anchor-links')) {
    class PsAnchorLinks extends HTMLElement {
      connectedCallback() {
        if (window.__psAnchors) return;
        window.__psAnchors = this;
        this.userScrolled = false;
        this.onClick = (e) => this.click(e);
        document.addEventListener('click', this.onClick);
        const stop = () => { this.userScrolled = true; };
        window.addEventListener('wheel', stop, { passive: true, once: true });
        window.addEventListener('touchmove', stop, { passive: true, once: true });
        window.addEventListener('keydown', (e) => { if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(e.key)) stop(); });
        this.map = {};
        try {
          const node = this.querySelector('[data-anchor-map]');
          (node ? JSON.parse(node.textContent) : []).forEach((line) => {
            const i = String(line).indexOf('=');
            if (i < 1) return;
            const name = line.slice(0, i).trim().replace(/^#/, '').toLowerCase();
            const id = line.slice(i + 1).trim().replace(/^#/, '');
            if (name && id) this.map[name] = id;
          });
        } catch (err) {}
        if (window.location.hash) this.landing();
      }
      disconnectedCallback() {
        if (window.__psAnchors === this) { window.__psAnchors = null; document.removeEventListener('click', this.onClick); }
      }
      find(hash) {
        if (!hash || hash.length < 2) return null;
        let id = hash.slice(1);
        try { id = decodeURIComponent(id); } catch (e) {}
        const safe = id.replace(/["\\]/g, '');
        const mapped = this.map[id.toLowerCase()];
        let el = (mapped && document.getElementById(mapped)) || document.getElementById(id) || document.querySelector('[data-anchor="' + safe + '"], [name="' + safe + '"]');
        if (!el && /^[\w-]+$/.test(id)) {
          const key = id.toLowerCase().replace(/-/g, '_');
          el = Array.from(document.querySelectorAll('[id^="shopify-section-"]')).find((s) => s.id.toLowerCase().endsWith('__' + key)) || null;
        }
        return el;
      }
      headerOffset() {
        let h = 0;
        const x = Math.max(1, Math.round(window.innerWidth / 2));
        const seen = new Set();
        (document.elementsFromPoint ? document.elementsFromPoint(x, 2) : []).forEach((el) => {
          for (let n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
            if (seen.has(n)) break;
            seen.add(n);
            const p = getComputedStyle(n).position;
            if (p === 'fixed' || p === 'sticky') {
              const r = n.getBoundingClientRect();
              if (r.top <= 2 && r.bottom > h && r.height < window.innerHeight * 0.5) h = r.bottom;
              break;
            }
          }
        });
        return h + (parseInt(this.dataset.extra, 10) || 0);
      }
      scroller() {
        const w = document.querySelector('.page-wrapper');
        if (w && /(auto|scroll)/.test(getComputedStyle(w).overflowY) && w.scrollHeight > w.clientHeight + 1) return w;
        return document.scrollingElement || document.documentElement;
      }
      scrollToEl(el, smooth) {
        if (el.tagName === 'DETAILS') el.open = true;
        const sc = this.scroller();
        const isRoot = sc === document.scrollingElement || sc === document.documentElement;
        const base = isRoot ? 0 : sc.getBoundingClientRect().top;
        const top = el.getBoundingClientRect().top - base + sc.scrollTop - this.headerOffset();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const opts = { top: Math.max(0, Math.round(top)), behavior: smooth && !reduce && this.dataset.smooth === 'true' ? 'smooth' : 'instant' };
        if (isRoot) window.scrollTo(opts); else sc.scrollTo(opts);
      }
      closeMenus() {
        document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
        document.querySelectorAll('details[open]').forEach((d) => { if (d.closest('header, .shopify-section-group-header-group')) d.open = false; });
        document.documentElement.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');
      }
      click(e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        const a = e.target.closest('a[href*="#"]');
        if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
        const raw = a.getAttribute('href') || '';
        let url;
        try { url = new URL(a.href, window.location.href); } catch (err) { return; }
        if (url.origin !== window.location.origin || !url.hash || url.hash === '#') return;
        const samePage = raw.charAt(0) === '#' || (url.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '') && url.search === window.location.search);
        if (!samePage) return;
        const el = this.find(url.hash);
        if (el) {
          e.preventDefault();
          const wasMenu = !!a.closest('header, .shopify-section-group-header-group, [role="dialog"]');
          if (wasMenu) this.closeMenus();
          setTimeout(() => this.scrollToEl(el, true), wasMenu ? 320 : 0);
          if (window.location.hash !== url.hash) history.pushState(null, '', url.hash);
          return;
        }
        if (raw.charAt(0) === '#') {
          e.preventDefault();
          window.location.href = (this.dataset.fallback || '/') + url.hash;
        }
      }
      landing() {
        const hash = window.location.hash;
        const run = () => {
          if (this.userScrolled) return;
          const el = this.find(hash);
          if (!el || el.closest('ps-faq')) return;
          this.scrollToEl(el, false);
        };
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        requestAnimationFrame(run);
        setTimeout(run, 250);
        if (document.readyState === 'complete') setTimeout(run, 700);
        else window.addEventListener('load', () => { run(); setTimeout(run, 500); }, { once: true });
      }
    }
    customElements.define('ps-anchor-links', PsAnchorLinks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.pstInit) return;
      root.dataset.pstInit = '1';
      var items = root.querySelectorAll('[data-reveal]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!root.classList.contains('pst--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.1 });
      items.forEach(function (el) { io.observe(el); });
    }
    function run() { document.querySelectorAll('.pst').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.pst'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.revInit) return;
      root.dataset.revInit = '1';
      var items = root.querySelectorAll('[data-reveal]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!root.classList.contains('psy--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.1 });
      items.forEach(function (el) { io.observe(el); });
    }
    function run() { document.querySelectorAll('.psy').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.psy'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-stripes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.pssInit) return;
      root.dataset.pssInit = '1';
      var items = root.querySelectorAll('[data-reveal]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!root.classList.contains('pss--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.1 });
      items.forEach(function (el) { io.observe(el); });
    }
    function run() { document.querySelectorAll('.pss').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.pss'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-values"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.revInit) return;
      root.dataset.revInit = '1';
      var items = root.querySelectorAll('[data-reveal]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!root.classList.contains('psv--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
      var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.1 });
      items.forEach(function (el) { io.observe(el); });
    }
    function run() { document.querySelectorAll('.psv').forEach(init); }
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.psv'); if (r) init(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petit-sol-wishlist"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('ps-grid')) {
    const WKEY = 'petitsol:wishlist';
    const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
    const writeWish = (list) => {
      try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
      document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.hidden = list.length === 0; });
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list, count: list.length } }));
    };

    class PsGrid extends HTMLElement {
      connectedCallback() {
        const root = this.closest('.psg');
        this.syncWish();
        this.addEventListener('click', (e) => this.onClick(e));
        this.onDoc = (e) => { if (!this.contains(e.target)) this.closeAll(); };
        this.onKey = (e) => { if (e.key === 'Escape') this.closeAll(true); };
        this.onWish = () => this.syncWish();
        document.addEventListener('click', this.onDoc);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('wishlist:change', this.onWish);
        if (root) this.reveal(root);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onDoc);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('wishlist:change', this.onWish);
      }
      reveal(root) {
        const items = root.querySelectorAll('[data-reveal]');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!root.classList.contains('psg--reveal') || reduce || !('IntersectionObserver' in window)) { items.forEach((el) => el.classList.add('is-in')); return; }
        const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.1 });
        items.forEach((el) => io.observe(el));
      }
      syncWish() {
        const list = readWish();
        this.querySelectorAll('[data-wish]').forEach((b) => {
          const on = list.includes(b.dataset.wish);
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      onClick(e) {
        const wish = e.target.closest('[data-wish]');
        if (wish) {
          e.preventDefault();
          let list = readWish();
          const h = wish.dataset.wish;
          list = list.includes(h) ? list.filter((x) => x !== h) : list.concat(h);
          writeWish(list);
          return;
        }
        const quick = e.target.closest('[data-quick]');
        if (quick) {
          e.preventDefault();
          const card = quick.closest('.psg__card');
          const open = card.classList.contains('is-quick');
          this.closeAll();
          if (!open) this.openCard(card);
          return;
        }
        const add = e.target.closest('[data-add]');
        if (add && !add.disabled) {
          e.preventDefault();
          this.addToCart(add);
        }
      }
      openCard(card) {
        const panel = card.querySelector('[data-panel]');
        const btn = card.querySelector('[data-quick]');
        if (!panel) return;
        card.classList.add('is-quick');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        const first = panel.querySelector('[data-add]:not(:disabled)');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), 50);
      }
      closeAll(focus) {
        this.querySelectorAll('.psg__card.is-quick').forEach((card) => {
          card.classList.remove('is-quick');
          const btn = card.querySelector('[data-quick]');
          if (btn) { btn.setAttribute('aria-expanded', 'false'); if (focus) btn.focus({ preventScroll: true }); }
        });
      }
      sectionIds() {
        const ids = [];
        document.querySelectorAll('cart-items-component[data-section-id], [data-cart-section-id]').forEach((el) => {
          const id = el.dataset.sectionId || el.dataset.cartSectionId;
          if (id && !ids.includes(id)) ids.push(id);
        });
        return ids;
      }
      root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
      async cartCount() {
        const r = await fetch(this.root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        const c = await r.json();
        return c.item_count || 0;
      }
      async waitForCount(before, ms) {
        const end = Date.now() + ms;
        while (Date.now() < end) {
          await new Promise((res) => setTimeout(res, 300));
          try { if ((await this.cartCount()) > before) return true; } catch (e) {}
        }
        return false;
      }
      async addToCart(btn) {
        const card = btn.closest('.psg__card');
        const msg = card ? card.querySelector('[data-msg]') : null;
        const pf = card ? card.querySelector('product-form-component') : null;
        const form = pf ? pf.querySelector('form') : null;
        const input = form ? form.querySelector('input[name="id"]') : null;
        const variantId = btn.dataset.add;
        if (this.busy) return;
        this.busy = true;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        if (msg) msg.textContent = '';
        try {
          const before = await this.cartCount();
          if (pf && form && input && customElements.get('product-form-component') && typeof form.requestSubmit === 'function') {
            input.value = variantId;
            input.disabled = false;
            const submitter = form.querySelector('button[type="submit"], input[type="submit"]');
            if (submitter) submitter.disabled = false;
            if (submitter) form.requestSubmit(submitter); else form.requestSubmit();
          } else {
            const res = await fetch(this.root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
          }
          const ok = await this.waitForCount(before, 6000);
          if (!ok) throw new Error(this.dataset.error);
          if (msg) msg.textContent = this.dataset.added;
          this.closeAll();
          this.openDrawer();
        } catch (err) {
          if (msg) msg.textContent = (err && err.message) || this.dataset.error;
        } finally {
          this.busy = false;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }
      }
      openDrawer() {
        document.dispatchEvent(new CustomEvent('petitsol:cart-updated'));
        setTimeout(() => {
          const td = document.getElementById('cart-drawer');
          if (td && typeof td.open === 'function') { if (!td.isOpen) td.open(); return; }
          const cdc = document.querySelector('cart-drawer-component');
          if (cdc) {
            const dlg = cdc.closest('dialog') || cdc.querySelector('dialog');
            if (dlg && dlg.open) return;
            if (typeof cdc.open === 'function') { cdc.open(); return; }
            if (typeof cdc.showDialog === 'function') { cdc.showDialog(); return; }
          }
          window.location.href = this.root() + 'cart';
        }, 350);
      }
    }
    customElements.define('ps-grid', PsGrid);
  }

  if (!customElements.get('ps-wishlist')) {
    const WKEY = 'petitsol:wishlist';
    const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
    const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    class PsWishlist extends HTMLElement {
      connectedCallback() {
        this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.grid = this.querySelector('[data-grid]');
        this.state = { type: '', color: '', size: '', sort: 'saved' };
        this.addEventListener('click', (e) => this.onClick(e));
        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-size]')) { this.state.size = e.target.value; this.apply(); }
          if (e.target.matches('[data-sort]')) { this.state.sort = e.target.value; this.apply(); }
        });
        this.onWish = () => this.syncRemoved();
        document.addEventListener('wishlist:change', this.onWish);
        this.load();
      }
      disconnectedCallback() { document.removeEventListener('wishlist:change', this.onWish); }
      async load() {
        const list = readWish();
        const loading = this.querySelector('[data-loading]');
        if (!list.length) { if (loading) loading.hidden = true; this.showEmpty(true); return; }
        const file = this.dataset.sectionFile || 'petit-sol-wishlist';
        const cards = await Promise.all(list.map(async (h) => {
          try {
            const res = await fetch(this.root + 'products/' + encodeURIComponent(h) + '?section_id=' + encodeURIComponent(file));
            if (!res.ok) return null;
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            return doc.querySelector('[data-wcard]');
          } catch (e) { return null; }
        }));
        if (loading) loading.hidden = true;
        this.cards = [];
        cards.forEach((c, i) => {
          if (!c) return;
          c.dataset.order = String(i);
          c.querySelectorAll('.psg__card').forEach((a) => a.classList.add('is-in'));
          this.grid.appendChild(c);
          this.cards.push(c);
        });
        if (typeof this.grid.syncWish === 'function') this.grid.syncWish();
        this.build();
        this.apply();
      }
      live() { return (this.cards || []).filter((c) => c.isConnected); }
      build() {
        const cards = this.live();
        const bar = this.querySelector('[data-bar]');
        if (!cards.length) { if (bar) bar.hidden = true; this.showEmpty(true); return; }
        if (bar) bar.hidden = false;
        this.showEmpty(false);
        const types = {}; const colors = {}; const sizes = [];
        cards.forEach((c) => {
          if (c.dataset.type) types[c.dataset.type] = (types[c.dataset.type] || 0) + 1;
          if (c.dataset.color && c.dataset.sw) colors[c.dataset.color] = c.dataset.sw;
          c.dataset.sizes.split('|').filter(Boolean).forEach((s) => { if (!sizes.includes(s)) sizes.push(s); });
        });
        const pills = this.querySelector('[data-pills]');
        let html = '<button type="button" class="psw__pill" data-type-pill="" aria-pressed="' + (this.state.type === '' ? 'true' : 'false') + '">♡ ' + esc(this.dataset.savedLabel || 'Saved') + ' <small>' + cards.length + '</small></button>';
        Object.keys(types).forEach((t) => { html += '<button type="button" class="psw__pill" data-type-pill="' + esc(t) + '" aria-pressed="' + (this.state.type === t ? 'true' : 'false') + '">' + esc(t) + ' <small>' + types[t] + '</small></button>'; });
        if (pills) pills.innerHTML = Object.keys(types).length > 1 ? html : html.split('</button>')[0] + '</button>';
        const sw = this.querySelector('[data-swatches]');
        if (sw) sw.innerHTML = Object.keys(colors).length > 1 ? Object.keys(colors).map((n) => '<button type="button" class="psw__sw" data-color-pill="' + esc(n) + '" style="--sw: ' + esc(colors[n]) + ';" aria-label="' + esc(n) + '" title="' + esc(n) + '" aria-pressed="' + (this.state.color === n ? 'true' : 'false') + '"></button>').join('') : '';
        const sel = this.querySelector('[data-size]');
        const wrap = this.querySelector('[data-size-wrap]');
        if (sel) {
          const first = sel.options[0].outerHTML;
          sel.innerHTML = first + sizes.map((s) => '<option value="' + esc(s) + '"' + (this.state.size === s ? ' selected' : '') + '>' + esc(s) + '</option>').join('');
          if (wrap) wrap.hidden = sizes.length < 2;
        }
        const dots = this.querySelector('[data-dots]');
        if (dots) dots.innerHTML = cards.slice(0, 6).filter((c) => c.dataset.img).map((c) => '<span style="--tint: ' + esc(c.dataset.tint || this.dataset.defaultTint) + ';"><img src="' + esc(c.dataset.img) + '" alt="" loading="lazy"></span>').join('');
      }
      apply() {
        const cards = this.live();
        const st = this.state;
        let shown = 0;
        cards.forEach((c) => {
          const ok = (!st.type || c.dataset.type === st.type) && (!st.color || c.dataset.color === st.color) && (!st.size || c.dataset.sizes.includes('|' + st.size + '|'));
          c.hidden = !ok; if (ok) shown++;
        });
        const sorted = cards.slice().sort((a, b) => {
          if (st.sort === 'price-asc') return parseInt(a.dataset.price, 10) - parseInt(b.dataset.price, 10);
          if (st.sort === 'price-desc') return parseInt(b.dataset.price, 10) - parseInt(a.dataset.price, 10);
          if (st.sort === 'title') return a.dataset.title.localeCompare(b.dataset.title);
          return parseInt(a.dataset.order, 10) - parseInt(b.dataset.order, 10);
        });
        sorted.forEach((c) => this.grid.appendChild(c));
        const row = this.querySelector('[data-count-row]');
        const count = this.querySelector('[data-count]');
        const clear = this.querySelector('[data-clear]');
        if (row) row.hidden = !cards.length;
        if (count) count.textContent = shown + ' ' + (shown === 1 ? this.dataset.countOne : this.dataset.countWord);
        if (clear) clear.hidden = !(st.type || st.color || st.size);
        const none = this.querySelector('[data-none]');
        if (none) none.hidden = !(cards.length && shown === 0);
        this.querySelectorAll('[data-type-pill]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.typePill === st.type ? 'true' : 'false'));
        this.querySelectorAll('[data-color-pill]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.colorPill === st.color ? 'true' : 'false'));
      }
      showEmpty(on) {
        const empty = this.querySelector('[data-empty]');
        if (empty) empty.hidden = !on;
        const row = this.querySelector('[data-count-row]');
        if (row && on) row.hidden = true;
        const dots = this.querySelector('[data-dots]');
        if (dots && on) dots.innerHTML = '';
      }
      syncRemoved() {
        const list = readWish();
        const gone = this.live().filter((c) => !list.includes(c.dataset.handle));
        if (!gone.length) return;
        gone.forEach((c) => { c.classList.add('is-leaving'); });
        setTimeout(() => {
          gone.forEach((c) => c.remove());
          const cards = this.live();
          if (this.state.type && !cards.some((c) => c.dataset.type === this.state.type)) this.state.type = '';
          if (this.state.color && !cards.some((c) => c.dataset.color === this.state.color)) this.state.color = '';
          this.build();
          this.apply();
        }, 300);
      }
      onClick(e) {
        const tp = e.target.closest('[data-type-pill]');
        if (tp) { this.state.type = tp.dataset.typePill; this.apply(); return; }
        const cp = e.target.closest('[data-color-pill]');
        if (cp) { this.state.color = this.state.color === cp.dataset.colorPill ? '' : cp.dataset.colorPill; this.apply(); return; }
        if (e.target.closest('[data-clear]')) {
          this.state.type = ''; this.state.color = ''; this.state.size = '';
          const sel = this.querySelector('[data-size]'); if (sel) sel.value = '';
          this.apply(); return;
        }
        if (e.target.closest('[data-guide]')) { const d = this.querySelector('[data-guide-dialog]'); if (d && d.showModal) d.showModal(); return; }
        if (e.target.closest('[data-guide-close]')) { const d = this.querySelector('[data-guide-dialog]'); if (d) d.close(); return; }
        const dlg = e.target.closest('[data-guide-dialog]');
        if (dlg && e.target === dlg) dlg.close();
      }
    }
    customElements.define('ps-wishlist', PsWishlist);
  }

  } catch(e) { console.error(e); }
})();
})();
